/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { icpUsdRateGetApiV3IcpUsdPercentChange24h } from "../../funcs/icpUsdRateGetApiV3IcpUsdPercentChange24h.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$icpUsdRateGetApiV3IcpUsdPercentChange24h: ToolDefinition = {
  name: "icp-usd-rate-get-api-v3-icp-usd-percent-change-24h",
  description: ``,
  tool: async (client, ctx) => {
    const [result, apiCall] = await icpUsdRateGetApiV3IcpUsdPercentChange24h(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
